module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-300.bda729db.eot";